import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/yellowcalfcss/CreateBill.css';

export default function CreateBill() {
  const [billNumber, setBillNumber] = useState('');
  const [supplier, setSupplier] = useState('');
  const [billDate, setBillDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [currentItem, setCurrentItem] = useState('');
  const [currentQuantity, setCurrentQuantity] = useState('');
  const [currentUnitPrice, setCurrentUnitPrice] = useState('');
  const [items, setItems] = useState([]);
  const [errors, setErrors] = useState({});
  const [showItemValidation, setShowItemValidation] = useState(false);
  const [showQuantityValidation, setShowQuantityValidation] = useState(false);
  const [showPriceValidation, setShowPriceValidation] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const calculateItemTotal = () => {
    const qty = parseFloat(currentQuantity) || 0;
    const price = parseFloat(currentUnitPrice) || 0;
    return qty * price;
  };





  const addItem = () => {
    setShowItemValidation(!currentItem);
    setShowQuantityValidation(!currentQuantity);
    setShowPriceValidation(!currentUnitPrice);

    if (currentItem && currentQuantity && currentUnitPrice) {
      const newItem = {
        item: currentItem,
        quantity: parseFloat(currentQuantity),
        unitPrice: parseFloat(currentUnitPrice),
        total: calculateItemTotal()
      };
      setItems([...items, newItem]);
      setCurrentItem('');
      setCurrentQuantity('');
      setCurrentUnitPrice('');
      setShowItemValidation(false);
      setShowQuantityValidation(false);
      setShowPriceValidation(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!billNumber.trim()) {
      newErrors.billNumber = 'Bill Number cannot be blank';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = () => {
    if (validateForm()) {
      setSuccessMessage('Bill created successfully!');
    }
  };


  return (
    <div className="create-wrapper">
      <Container fluid className="create-main-container">
        <div className="title-section">
          <h3>Create Bill</h3>
        </div>

        {successMessage && (
          <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible className="success-alert">
            {successMessage}
          </Alert>
        )}

        <div className="form-row-card">
          <div className="row-grid-two">
            <Form.Group controlId="billNumber">
              <Form.Label>
                Bill Number <span className="required-star">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter bill number"
                value={billNumber}
                onChange={(e) => setBillNumber(e.target.value)}
                isInvalid={!!errors.billNumber}
              />
              <Form.Control.Feedback type="invalid">
                {errors.billNumber}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="supplier">
              <Form.Label>
                Supplier <span className="required-star">*</span>
              </Form.Label>
              <Form.Select
                value={supplier}
                onChange={(e) => setSupplier(e.target.value)}
              >
                <option value="">Select</option>
                <option value="supplier1">Vipin</option>
                <option value="supplier2">AKBAR SHAN</option>
                <option value="supplier3">ANTHINY</option>
                <option value="supplier4">AMAR</option>
              </Form.Select>
            </Form.Group>
          </div>


          <div className="form-row-card">
            <div className="row-grid-two">
              <Form.Group controlId="billDate">
                <Form.Label>Bill Date</Form.Label>
                <Form.Control
                  type="date"
                  value={billDate}
                  onChange={(e) => setBillDate(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="dueDate">
                <Form.Label>Due Date</Form.Label>
                <Form.Control
                  type="date"
                  value={dueDate}
                  onChange={(e) => setDueDate(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>

          <div className="form-row-card">
            <div className="row-grid-four">
              <Form.Group>
                <Form.Label>Item</Form.Label>
                <select
                  className="selectpicker form-control"
                  data-live-search="true"
                  title="Select Item"
                  value={currentItem}
                  onChange={(e) => setCurrentItem(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Pen">Pen</option>
                  <option value="Pencil">Pencil</option>
                  <option value="Notebook">Notebook</option>
                  <option value="Eraser">Eraser</option>
                  <option value="Marker">Marker</option>
                  <option value="Scale">Scale</option>
                </select>
                {showItemValidation && !currentItem && (
                  <div className="invalid-feedback d-block">This field is required.</div>
                )}
              </Form.Group>


              <Form.Group>
                <Form.Label>Quantity</Form.Label>
                <Form.Control
                  type="number"
                  value={currentQuantity}
                  onChange={(e) => setCurrentQuantity(e.target.value)}
                  placeholder="0"
                  isInvalid={showQuantityValidation && !currentQuantity}
                />
                <Form.Control.Feedback type="invalid">
                  This field is required.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group>
                <Form.Label>Unit Price</Form.Label>
                <Form.Control
                  type="number"
                  value={currentUnitPrice}
                  onChange={(e) => setCurrentUnitPrice(e.target.value)}
                  placeholder="0.00"
                  isInvalid={showPriceValidation && !currentUnitPrice}
                />
                <Form.Control.Feedback type="invalid">
                  This field is required.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group>
                <Form.Label>Item Total</Form.Label>
                <div className="total-input-wrapper">
                  <Form.Control
                    type="number"
                    value={calculateItemTotal().toFixed(2)}
                    readOnly
                  />
                  <Button
                    className="add-item-btn"
                    onClick={addItem}
                  >
                    +
                  </Button>
                </div>
              </Form.Group>
            </div>
          </div>

          {items.length > 0 && (
            <>
              <div className="items-title-section">
                <h5>Added Items</h5>
              </div>

              <div className="items-table-header">
                <div className="items-table-grid">
                  <div>Item</div>
                  <div>Quantity</div>
                  <div>Unit Price</div>
                  <div>Total</div>
                </div>
              </div>

              <div className="items-data-list">
                {items.map((item, index) => (
                  <div key={index} className="items-data-row">
                    <div className="items-table-grid">
                      <div>{item.item}</div>
                      <div>{item.quantity}</div>
                      <div>${item.unitPrice.toFixed(2)}</div>
                      <div>${item.total.toFixed(2)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="submit-section">
            <Button onClick={handleCreate} className="submit-btn">
              Create Bill
            </Button>
          </div> </div>
      </Container>
    </div>

  );
}
